class DiscontinuedPopup extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === "/challenge") {
      return;
    }

    this.sectionId = this.dataset.sectionId;
    this.popup = this.querySelector(".discontinued-popup");
    this.overlay = this.querySelector(".popup-overlay");
    this.position = this.dataset.position;

    this.classes = {
      bodyClass: "discontinued-popup--open",
      activeClass: "is-active",
      closingClass: "is-closing",
      overlayActiveClass: "overlay-active",
    };

    this.init();
  }

  connectedCallback() {
    if (Shopify && Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener(
        "shopify:section:load",
        this.onShopifySectionLoad
      );
      document.addEventListener("shopify:section:select", this.onSectionSelect);
      document.addEventListener(
        "shopify:section:deselect",
        this.onSectionDeselect
      );
    }
  }

  disconnectedCallback() {
    if (Shopify && Shopify.designMode) {
      document.removeEventListener(
        "shopify:section:load",
        this.onShopifySectionLoad
      );
      document.removeEventListener(
        "shopify:section:select",
        this.onSectionSelect
      );
      document.removeEventListener(
        "shopify:section:deselect",
        this.onSectionDeselect
      );
      document.body.classList.remove(this.classes.bodyClass);
    }
  }

  onSectionLoad(event) {
    if (
      this.filterShopifyEvent &&
      typeof this.filterShopifyEvent === "function"
    ) {
      this.filterShopifyEvent(event, this, () => this.open.bind(this));
    } else {
      this.open();
    }
  }

  onSectionSelect(event) {
    if (
      this.filterShopifyEvent &&
      typeof this.filterShopifyEvent === "function"
    ) {
      this.filterShopifyEvent(event, this, this.open.bind(this));
    } else {
      this.open();
    }
  }

  onSectionDeselect(event) {
    if (
      this.filterShopifyEvent &&
      typeof this.filterShopifyEvent === "function"
    ) {
      this.filterShopifyEvent(event, this, this.close.bind(this));
    } else {
      this.close();
    }
  }

  init() {
    if (!this.popup) {
      return;
    }

    // Don't show in Shopify design mode
    if (Shopify && Shopify.designMode) {
      return;
    }

    // Set up event listeners
    this.setupEventListeners();

    // Show popup immediately
    this.open();
  }

  setupEventListeners() {
    // Close button
    this.querySelectorAll("[data-popup-toggle]").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass)
      ? this.close()
      : this.open();
  }

  open() {
    if (!this.popup) return;

    this.classList.remove("hidden");
    this.popup.classList.add(this.classes.activeClass);

    // Show overlay
    if (this.overlay) {
      this.overlay.classList.add(this.classes.overlayActiveClass);
    }

    // Add body class for center positioned popups
    if (this.position === "center") {
      document.body.classList.add(this.classes.bodyClass);
    }
  }

  close() {
    if (!this.popup) return;

    this.popup.classList.add(this.classes.closingClass);

    // Hide overlay immediately
    if (this.overlay) {
      this.overlay.classList.remove(this.classes.overlayActiveClass);
    }

    // Remove all classes immediately
    this.popup.classList.remove(this.classes.activeClass);
    this.popup.classList.remove(this.classes.closingClass);

    if (this.position === "center") {
      document.body.classList.remove(this.classes.bodyClass);
    }
    this.classList.add("hidden");
  }
}

// Register the custom element
customElements.define("discontinued-popup", DiscontinuedPopup);

// Helper function for Shopify events (if not already defined)
if (typeof filterShopifyEvent === "undefined") {
  window.filterShopifyEvent = function (event, element, callback) {
    if (event.detail.sectionId === element.dataset.sectionId) {
      callback();
    }
  };
}
